import React from 'react';
import ShowItems from '../ShowItems';

export default function ShowStatus({ data }) {
    return (
        <div>
            <ShowItems items={data.items} />
        </div>
    )
}